import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {ANIMATION} from "../../../../constants/fields.constants";
import {DataService} from "../../../../../services/data.service";
import {DATA_FIELD_CLASS, INPUT_CONTAINER_CLASS} from "../../../../constants/data.constants";
import {InputType} from "../../../../../common/interfaces/data.interfaces";


@Component({
  selector: 'data-input',
  templateUrl: './data-input.component.html',
  styleUrls: ['./data-input.component.scss']
})
export class DataInputComponent implements OnInit {
  @Input() label = undefined;
  @Input() subLabel = undefined;
  @Input() animation = ANIMATION;
  @Input() active = false;
  @Input() showCancel = false;

  @Input() toolTip = undefined;
  @Input() labelToolTip = undefined;

  @Input() icon = undefined;
  @Input() suffixIcon = undefined;
  @Input() order = 2;

  @Input() value = undefined;
  @Input() format = 'yyyy-MM-dd';
  @Input() placeholder = '';
  @Input() maxWidth = '200px';

  @Input() type:InputType | any = 'text';
  @Input() multiple = true;
  @Input() options = [];

  @Input() inContainer = true;

  @Output() labelClick = new EventEmitter<boolean>(true);
  @Output() change = new EventEmitter<any>();

  dataFieldClass = DATA_FIELD_CLASS;
  inputContainerClass = INPUT_CONTAINER_CLASS;

  constructor(private ds:DataService){}

  ngOnInit(): void {
    if(this.type == 'select' && !this.suffixIcon) this.suffixIcon = 'edit';
    if(this.type == 'date' && !this.placeholder) this.placeholder = this.ds.formatDate(new Date);
  }

  onChange(value){
    console.log(value)
    if(this.type == 'date') value = this.ds.formatDate(value,this.format);
    this.change.emit(value);
  }


}
